/**
 * Layout global engagement context — J5.
 * Set by <Layout> on every render so NavItem/GroupItem subcomponents
 * (defined at module scope) can read `engagement_type` without a
 * ReferenceError, and without re-plumbing every prop path.
 *
 * This is a plain module-scoped ref. React never rebinds it. Safe
 * because Layout re-renders bump it before any NavItem re-renders.
 */
export const layoutCtx = { engagementType: undefined };
